import { LocalDate } from '@js-joda/core';

import { useFormController } from '@dreryk/react-common';

import { RemovalDatePicker } from './fields/RemovalDatePicker';
import { RemovalReasonTextarea } from './fields/RemovalReasonTextarea';
import { StyledRemovalChronicDiseaseForm } from './RemovalChronicDiseaseForm.styled';
import { RemovalChronicDiseaseController, RemovalChronicDiseaseFormBean } from './RemovalChronicDiseaseForm.types';

type RemovalChronicDiseaseFormRenderProps = Pick<RemovalChronicDiseaseController, 'formState' | 'handleSubmit'>;

type RemovalChronicDiseaseFormRenderer = (renderProps: RemovalChronicDiseaseFormRenderProps) => JSX.Element;

type RemovalChronicDiseaseFormProps = {
   readonly visitBeginDate: Date;
   readonly children: RemovalChronicDiseaseFormRenderer;
};

export const RemovalChronicDiseaseForm = (props: RemovalChronicDiseaseFormProps): JSX.Element => {
   const { formState, handleSubmit, register } = useFormController<RemovalChronicDiseaseFormBean>({
      chronicDiseaseRemovalReason: null,
      chronicDiseaseRemovalDate: LocalDate.now(),
   });

   return (
      <>
         <StyledRemovalChronicDiseaseForm noValidate>
            <RemovalDatePicker register={register} visitBeginDate={props.visitBeginDate} />
            <RemovalReasonTextarea register={register} />
         </StyledRemovalChronicDiseaseForm>

         {props.children({ formState: formState, handleSubmit: handleSubmit })}
      </>
   );
};
